import { render, staticRenderFns } from "./PersonnelDialog.vue?vue&type=template&id=b2d03402&"
import script from "./PersonnelDialog.vue?vue&type=script&lang=js&"
export * from "./PersonnelDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports